import React, { useEffect } from "react";
import { utils } from "helper";
import moment from "moment";
import { Images } from "constants";
import { FaDownload } from "react-icons/fa6";

const BiltyFormat3 = ({ buityFormatePreview, showPodPreview = false, podPreviewData }) => {
    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
     @page {
    margin: 0px;
    padding: 0px;
}

/* Note: Necessary for the pdf */
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');

body {
    margin: 0;
}

/* Invoice 1 */

  .invoice-box {
            font-size: 12px;
            line-height: 16px;
            font-family: 'Roboto', sans-serif;
            color: #000;
            padding: 0px 6px;
        }

        .invoice-box table {
            width: 100%;
            text-align: left;
            border-collapse: collapse;
        }

        .top_heading p {
            margin-top: 0px;
            margin-bottom: 2px;
            font-size: 11px;
            font-weight: 400;
            line-height: normal;
        }

        .top_heading .h1 {
            font-size: 21.6px !important;
            line-height: normal;
            margin-bottom: 3px;
            display: block;
            font-weight: bold;
        }

        .invoice-box table td {
            vertical-align: top;
        }

        .top_heading {
            padding: 5.5px 0 5.5px 10px;
             text-align: left;
        }

        .invoice-box table tr.information table td {
            padding-bottom: 40px;
        }

        .invoice-box table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: bold;
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px;
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: bold;
        }

        .__lrTable_ thead tr,
        .__lrTable_ tfoot tr {
            background-color: #EFEFEF;
            -webkit-print-color-adjust: exact;
            border: 1px solid #BDBDBD;
        }

        .__lrTable_ thead tr td,
        .__lrTable_ tbody tr td,
        .__lrTable_ tfoot tr td {
            font-size: 10px;
            padding: 3px 6px;
        }

        .__lrTable_ tbody tr {
            border: 1px solid #BDBDBD;
        }

        .__drvSup_details {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            padding-top: 7px;
            padding-bottom: 12px;
            width: 100%;
        }

        .__drvF {
            flex: 0 0 calc(33.33% - 12px);
            border-radius: 4px;
            border: 1px solid #BDBDBD;
            background: #FFF;
            -webkit-print-color-adjust: exact;
            padding: 10px 0;
        }

        .__totFrt {
            width: 100%;
            max-width: 150px;
            margin-left: auto;
            border: 1px solid #BDBDBD;
        }

        .__inChl_frt {
            font-size: 9px;
            line-height: normal;
            display: flex;
            justify-content: space-between;
            min-height: 16px;
            align-items: center;
            padding: 0px 7px 0px 9px;
            border-bottom: 1px solid #BDBDBD;
        }

        .sheet.padding-2mm {
            padding: 8px 2mm;
            background: white;
            page-break-after: always;
        }

        .sheet.padding-2mm:last-child {
            page-break-after: auto;
        }

        .sheet-content {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }

        @media (max-width: 319px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-content {
                margin: 0 auto;
            }
        }

        @media print {
            .sheet-content {
                transform: scale(1) !important;
            }
        }
            

/* Invoice 2  */

/* first */

.invoice-box {
            font-size: 12px;
            line-height: 16px;
            font-family: 'Roboto', sans-serif;
            color: #222;
            padding: 0px;
        }

        .height_410 {
            position: relative;
        }

        table.border_t_b.Extra_p.p_b_0 td {
            padding-bottom: 5px !important;
        }

        .overly_table tr:last-child td {
            border-bottom: none;
        }

        .address_outer p {
            height: 30px;
            margin-bottom: 5px !important;
        }

        .bold_text {
            font-weight: bold;
        }

        .trip_no_detailsa {
            position: absolute;
            bottom: 0px;
            font-size: 10px;
        }

        .border_box {
            border: 1px solid #cccc;
        }

        .termsand_condiotn_relative {
            position: relative;
        }

        .p_0 {
            padding: 0px !important;
        }

        .Gst_in {
            font-weight: 900 !important;
        }

        .Extra_p td {
            padding: 5px 10px !important;
        }

        .address_outer p {
            margin: 0;
        }

        .Extra_p {
            border-top: 1px solid #ccc;
            position: relative;
        }

        .Signature_height {
            height: 2.3cm;
        }

        .__signBottom {
            position: absolute;
            bottom: 12px;
            width: 100%;
            text-align: center;
        }

        .invoice-box table {
            width: 100%;
            text-align: left;
            border-collapse: collapse;
        }

        .top_heading p {
            margin-top: 0px;
            margin-bottom: 0px;
            font-size: 11px;
            font-weight: 400;
            line-height: 16px;
        }

        .top_heading .h1 {
            margin: 0;
            font-size: 20px !important;
            margin-bottom: 0;
            margin-top: 0;
            font-weight: bold;
        }

        .invoice-box table td {
            vertical-align: top;
        }

        .text-left {
            text-align: left;
        }

        .border_table thead td {
            font-weight: bold;
            padding: 2px 5px;
            font-size: 12px;
        }

        .border_table thead td:nth-child(1) {
            border-left: none;
        }

        .top_heading {
            padding: 6px 0 4px 15px;
        }

        span.number-with-bg {
            line-height: 16px;
            width: 16px;
            height: 16px;
            display: inline-block;
            background-color: #000 !important;
            color: #fff !important;
            text-align: center;
            border-radius: 30px;
            margin-left: 4px;
            margin-top: -30px;
            -webkit-print-color-adjust: exact;
        }

        .invoice-box table tr.information table td {
            padding-bottom: 40px;
        }

        .invoice-box table tr.heading td {
            background: #eee;
            border-bottom: 1px solid #ddd;
            font-weight: bold;
            
        }

        .border_table td {
            border: 1px solid #ccc;
            padding: 0px 5px;
            border-right: none;
        }

        .invoice-box table tr.details td {
            padding-bottom: 20px;
        }

        .Heading_right {
            background: #efefef !important;
            margin: 0;
            padding: 4px 8px;
            font-size: 16px;
            border-bottom: 1px solid #ccc;
            -webkit-print-color-adjust: exact;
            border-top: 1px solid #ccc;
            margin-top: -1px;
            border-right: 1px solid #ccc;
          
        }

        @media print {
            .Heading_right {
                background: #efefef !important;
                -webkit-print-color-adjust: exact;
                border-top: 1px solid #ccc !important;
            }
        }

        .tfoot_bg td {
            padding: 2px 10px;
            background: #efefef !important;
            font-size: 12px;
            -webkit-print-color-adjust: exact;
        }

        @media print {
            .tfoot_bg td {
                padding: 2px 10px;
                background: #efefef !important;
                font-size: 12px;
                -webkit-print-color-adjust: exact;
            }
        }

        .invoice-box table tr.total td:nth-child(2) {
            border-top: 2px solid #eee;
            font-weight: bold;
        }

        table.table_right thead td {
            padding: 0px;
        }

        .table_right td {
            padding: 2px 10px;
        }

        .termsAndCondiotion {
            font-size: 10px;
            margin-top: 3px;
            margin-bottom: 3px;
        }

        .b_0 {
            border-bottom: 0 !important;
            border-top: 0 !important;
        }

        .width_35 {
            width: 19%;
        }

        .Address {
            height: 26px;
            line-height: 14px !important;
            margin-bottom: 5px !important;
            margin-top: 5px !important;
        }

        table.border_table tbody tr td:nth-child(1) {
            border-left: 0;
            width: 20%;
        }

        table.border_table tr td:nth-child(2) {
            width: 57%;
        }

        table.border_table tr td:nth-child(3) {
            width: 11%;
            border-right: 0px;
        }

        table.border_table tr td:nth-child(4) {
            width: 11%;
        }

        span.bold_text.width_100 {
            width: 100%;
            text-align: center;
            float: left;
        }

        .address_bottom {
            margin: 0;
            height: 38px;
            line-height: 12px;
            padding-top: 0px;
            margin-top: 0px;
            font-size: 10px;
            padding-bottom: 4px;
        }

        .address_bottom p {
            margin-bottom: 0px;
        }

        table.border_table .tfoot_bg td:nth-child(3) {
            border-right: 1px solid #ccc;
        }

        .height_410 {
            min-height: 328px;
            /* height: 328px; */
            /*border-right: 1px solid #ccc;*/
            position: relative;
            font-size: 11px;
            /* overflow: hidden; */
        }

        .height_410 td {
            height: 16.9px;
            line-height: 16.9px;
        }

        .overly_table {
            /* position: absolute; */
            width: 100%;
            /* top: 0px; */
        }

        .fixed_width {
            width: 200px;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 0px;
            text-overflow: ellipsis;
        }

        .oP_none {
            opacity: 0;
        }

        .lrCopy_space td {
            padding-top: 4.1px;
            padding-bottom: 5.1px;
        }

        span.poweredby {
            position: absolute;
            bottom: -10px;
            text-align: right;
            width: 100%;
            right: 4px;
            font-size: 9px;
            display: block;
        }

        span.orignal_copy {
            text-align: right;
            float: right;
            font-size: 10px;
            line-height: 17px;
        }

        tr.lrCopy_space.last_tr td {
            padding-bottom: 8px;
        }

        table.border_table.Table_border_none td {
            border-color: #fff;
        }

        .fixed_width {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 250px;
        }

        td.bold_text.text-right.total_div {
            width: 88.5%;
        }

        /* .scale-content {
      width: 210mm; / Set content width here /
      margin: 0 auto;
      transform-origin: top left;
      transition: transform 0.2s ease;
    } */

        .sheet.padding-2mm {
            padding: 2mm;
            background: white;
        }

        .sheet-content {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }

        @media (max-width: 280px) {
            .sheet-content {
                transform: scale(calc(17% * 2)) !important;
                transform-origin: 5px 0px;
            }

            html {
                overflow: hidden;
            }
        }

        @media (min-width: 281px) and (max-width: 319px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-content {
                margin: 0 auto;
            }
        }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);


    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: buityFormatePreview }} />

            <div className={podPreviewData?.length > 0 ? " __podPreview_flx" : ''}>
                {(showPodPreview && podPreviewData?.length > 0) ?
                    podPreviewData?.map((el, ind) => {
                        return (
                            <React.Fragment key={ind + el}>
                                <div className="__previewBxs_outer">
                                    {
                                        el?.split('.')?.at(-1) === 'pdf' ?
                                            <div className="__previewBxs" >
                                                <img
                                                    alt="Preview"
                                                    className="rounded-lg shadow-sm border"
                                                    src={Images.VEH_PDF_ICON.default}
                                                    style={{ width: '100%', height: '100%', objectFit: 'none', objectPosition: 'center' }}
                                                />
                                            </div>
                                            :
                                            <div className="__previewBxs" >
                                                <img
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    src={el}
                                                    alt="Preview"
                                                    className="rounded-lg shadow-sm border"
                                                />
                                            </div>
                                    }
                                    <button className="__downloadIcon" >
                                        <a href={el} target='_blank' className='__upEye_ico' style={{ fontSize: '18px' }}>
                                            <FaDownload />
                                        </a>
                                    </button>
                                    <p >POD {ind + 1}</p>
                                </div>
                            </React.Fragment>
                        )
                    })
                    :
                    <></>
                }
            </div>
        </>
    );
};

export default BiltyFormat3;
